import styles from "./investors.module.scss";
import back from "../icons/back.svg";

export default function Investors() {
  return (
    <div className={styles.page}>
      <div className={styles.ring1} />
      <div className={styles.ring2} />
      <div className={styles.aurora1} />
      <div className={styles.aurora2} />

      <header className={styles.header}>
        <div className={styles.header__logo}>
          <img src="/logoname.png" alt="Sowiz" />
        </div>
      </header>

      <div className={styles.main}>
        <div
          style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 32, cursor: "pointer", color: "#8b949e", fontSize: 14, fontWeight: 500 }}
          onClick={() => { window.location.href = "/"; }}
          onMouseEnter={e => e.currentTarget.style.color = "#58a6ff"}
          onMouseLeave={e => e.currentTarget.style.color = "#8b949e"}
        >
          <img src={back} alt="Back" style={{ width: 20, height: 20, opacity: 0.6 }} />
          <span>Back</span>
        </div>

        <p className={styles.company__name}>SOWIZ SOLUTIONS PRIVATE LIMITED</p>
        <p className={styles.company__info}>
          <strong>Regd. Address:</strong> House No. PVT No. 06, Plot No-53 Ground Floor,
          BLK-A Rama Road, Najafgarh Road, South Delhi, Delhi, India – 110015
        </p>
        <p className={styles.company__info}>
          <strong>CIN:</strong> U72900DL2022FTC408348
        </p>

        <div className={styles.divider} />

        <p className={styles.section__title}>Financial Results</p>
        <p className={styles.section__sub}>
          Audited Standalone Financial Results for the Last Three Years &nbsp;·&nbsp; (Rs. in million except per share data)
        </p>

        <div className={styles.table__wrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Particulars</th>
                <th>FY 2024</th>
                <th>FY 2023</th>
                <th>FY 2022</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Reserves (Excl. Revaluation Reserve)</td>
                <td>(0.43)*</td>
                <td>(0.01)*</td>
                <td>—</td>
              </tr>
              <tr>
                <td>Sales</td>
                <td>8.86</td>
                <td>—</td>
                <td>—</td>
              </tr>
              <tr>
                <td>Profit / (Loss) after Tax</td>
                <td>(0.42)*</td>
                <td>(0.01)*</td>
                <td>—</td>
              </tr>
              <tr>
                <td>Earning per Share – Basic (Face Value ₹10)</td>
                <td>0.04</td>
                <td>—</td>
                <td>—</td>
              </tr>
              <tr>
                <td>Earning per Share – Diluted (Face Value ₹10)</td>
                <td>0.04</td>
                <td>—</td>
                <td>—</td>
              </tr>
              <tr>
                <td>Net Assets Value</td>
                <td>(33.24)*</td>
                <td>9.00</td>
                <td>—</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className={styles.table__note}>* Negative figures are shown in brackets.</p>
      </div>
    </div>
  );
}
